import { render, staticRenderFns } from "./dangerousGoodsListPictograms.vue?vue&type=template&id=286d9f84&scoped=true"
import script from "./dangerousGoodsListPictograms.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListPictograms.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodsListPictograms.vue?vue&type=style&index=0&id=286d9f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d9f84",
  null
  
)

export default component.exports